import { render, staticRenderFns } from "./NeedsOnboarding.vue?vue&type=template&id=c2a9c6ec&scoped=true&"
import script from "./NeedsOnboarding.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsOnboarding.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a9c6ec",
  null
  
)

export default component.exports